<template>
  <div id="productos">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="LISTADO DE CONJUNTOS" color="primary darken-4" dark>
            <div slot="widget-content">
              <div>
                <v-btn
                  color="success"
                  dark
                  fab
                  small
                  slot="activator"
                  @click="abrirDialogNuevoConjunto"
                >
                  <v-icon dark>add</v-icon>
                </v-btn>
                <form-conjunto
                  :conjunto="conjunto"
                  ref="dialogConjunto"
                  @onConjuntoAdded="onConjuntoAdded"
                  @onConjuntoUpdated="onConjuntoUpdated"
                >
                </form-conjunto>
              </div>

              <v-layout row wrap>
                <v-flex lg12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-text-field
                        flat
                        solo
                        prepend-icon="search"
                        placeholder="Búsqueda rápida"
                        v-model="search"
                        hide-details
                        class="hidden-sm-and-down"
                      ></v-text-field>
                      <v-btn icon>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                      <v-data-table
                        :headers="headers"
                        :search="search"
                        :items="conjuntos"
                        :rows-per-page-items="[
                          10,
                          25,
                          50,
                          { text: 'All', value: -1 },
                        ]"
                        class="elevation-1"
                        item-key="conjuntoId"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <v-avatar size="48">
                              <v-icon color="primary" medium
                                >local_offer</v-icon
                              >
                            </v-avatar>
                          </td>
                          <td>{{ props.item.nombreConjunto }}</td>
                          <td>
                            <v-text-field
                              label="Precio renta"
                              v-model="props.item.precioRenta"
                              :rules="[
                                (v) =>
                                  !!props.item.precioRenta ||
                                  'El campo es requerido',
                              ]"
                              prefix="$"
                              type="number"
                              @change="updatePreciosConjunto(props.item)"
                            ></v-text-field>
                          </td>
                          <td>
                            <v-text-field
                              label="Precio venta"
                              v-model="props.item.precioVenta"
                              :rules="[
                                (v) =>
                                  !!props.item.precioVenta ||
                                  'El campo es requerido',
                              ]"
                              prefix="$"
                              type="number"
                              @change="updatePreciosConjunto(props.item)"
                            ></v-text-field>
                          </td>
                          <td>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="primary"
                              small
                              @click="getConjunto(props.item.conjuntoId)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="pink"
                              small
                              @click="deleteConjunto(props.item.conjuntoId)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                        <v-alert
                          slot="no-results"
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                        >
                          La búsqueda para "{{ search }}" no encontró registros
                        </v-alert>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import formConjunto from "./FormConjunto";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

import conjuntoService from "@/services/conjuntoService";

export default {
  components: {
    VWidget,
    confirm,
    loadingAlert,
    snackBar,
    formConjunto,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "", align: "center", sortable: false },
        {
          text: "NOMBRE DEL CONJUNTO",
          align: "center",
          value: "nombreConjunto",
        },
        { text: "PRECIO RENTA", align: "center", value: "precioRenta" },
        { text: "PRECIO VENTA", align: "center", value: "precioVenta" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      conjuntos: [],
      conjunto: {
        conjuntoId: 0,
        nombreConjunto: "",
        precioRenta: 0,
        precioVenta: 0,
      },
    };
  },
  mounted() {
    this.getConjuntos();
  },
  methods: {
    getConjuntos() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      conjuntoService
        .getAll()
        .then((result) => {
          self.conjuntos = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getConjunto(conjuntoId) {
      let self = this;

      self.$store.state.loadingInfo.show = true;

      conjuntoService
        .get(conjuntoId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR CONJUNTO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";
          self.$refs.dialogConjunto.resetForm();
          self.conjunto = result;
          self.$refs.dialogConjunto.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteConjunto(conjuntoId) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR CONJUNTO",
          "¿Estás seguro de eliminar el conjunto, se eliminará toda la información relacionada a éste?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            conjuntoService
              .delete(conjuntoId)
              .then(() => {
                var i = this.conjuntos.findIndex(
                  (obj) => obj.conjuntoId == conjuntoId
                );
                self.conjuntos.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text =
                  "Conjunto eliminado con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                self.operationFailed(e);
                console.log(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    updatePreciosConjunto(conjuntoItem) {
      let self = this;
      if (conjuntoItem.precioRenta >= 0 && conjuntoItem.precioVenta >= 0) {
        conjuntoService
          .update(conjuntoItem)
          .then(() => {
            self.$store.state.snackbar.color = "success";
            self.$store.state.snackbar.text = "Precios actualizados";
            self.$store.state.snackbar.visible = true;
          })
          .catch((e) => {
            self.operationFailed(e);
            console.log(e);
          });
      }
    },
    onConjuntoAdded(conjunto) {
      this.conjuntos.push(conjunto);
    },
    onConjuntoUpdated(conjunto) {
      var i = this.conjuntos.findIndex(
        (obj) => obj.conjuntoId == conjunto.conjuntoId
      );
      this.conjuntos.splice(i, 1, conjunto);
    },
    abrirDialogNuevoConjunto() {
      this.$store.state.tituloForm = "AGREGAR CONJUNTO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogConjunto.resetForm();
      this.$refs.dialogConjunto.openDialog();
    },
  },
};
</script>
